// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vrEN","col":"styles_col__2---W","actions":"styles_actions__Ow1RT","conflict":"styles_conflict__231Jv"};